import { useLayoutEffect, useState } from "react";
import { matchesMedia } from "../utils/matchesMedia.js";
function useMatchesMedia(queries, once) {
    const mediaQueryLists = queries.map((q)=>matchesMedia(q));
    const getValue = ()=>mediaQueryLists.map((param)=>{
            let [mql] = param;
            return mql.matches;
        });
    const [value, setValue] = useState(getValue);
    useLayoutEffect(()=>{
        if (once) {
            return ()=>{
            // Silence is golden.
            };
        }
        const handler = ()=>setValue(getValue);
        mediaQueryLists.forEach((param)=>{
            let [, addListener] = param;
            return addListener(handler);
        });
        return ()=>mediaQueryLists.forEach((param)=>{
                let [, , removeListener] = param;
                return removeListener(handler);
            });
    }, [
        once
    ]);
    return value;
}
export { useMatchesMedia };
